import {
  AuthContextType,
  context,
} from '@porterin/booking-flow/src/order-review/view/contexts/auth/AuthContext';
import React from 'react';

export const AuthProvider = ({
  value,
  children,
}: {
  value: AuthContextType;
  children: React.ReactNode;
}) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
